import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeftIcon } from 'lucide-react';
import { snakReference, studyDesign } from '../../data/snak';
const EASE = [0.23, 1, 0.32, 1] as const;
interface StudyDesignOverlayProps {
  onClose: () => void;
}
export function StudyDesignOverlay({
  onClose
}: StudyDesignOverlayProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} transition={{
    duration: 0.18,
    ease: EASE
  }} className="fixed inset-0 z-50 flex items-center justify-center bg-ink/70 px-6 py-8" role="dialog" aria-modal="true" aria-label={studyDesign.headline} data-id="element-310" data-mp="3lmw3as7l225e">
      <motion.div initial={{
      opacity: 0,
      y: 10,
      scale: 0.98
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      scale: 0.98
    }} transition={{
      duration: 0.24,
      ease: EASE
    }} className="flex max-h-full w-full max-w-3xl flex-col overflow-hidden rounded-[28px] bg-paper shadow-soft" data-id="element-311" data-mp="32xz7gjwjf1l2">
        <div className="flex items-start justify-between gap-6 bg-navy px-8 py-5" data-id="element-312" data-mp="32c2z0arg6hc1">
          <div data-id="element-313" data-mp="2xej9uft7ok5b">
            <p className="flex items-center gap-2.5 text-[10px] uppercase tracking-micro text-mint" data-id="element-314" data-mp="2xcztkp7k293j">
              <span className="h-1.5 w-1.5 rounded-full bg-mint" aria-hidden="true" data-id="element-315" data-mp="3ca8vudyecxa1" />
              {studyDesign.eyebrow}
            </p>
            <h2 className="mt-2 font-display text-[22px] font-semibold leading-snug tracking-tight text-paper" data-id="element-316" data-mp="37a4e6klr5wi8">
              {studyDesign.headline}
            </h2>
          </div>
          <button type="button" onClick={onClose} className="flex h-10 shrink-0 items-center gap-2 rounded-full border border-sky/25 px-4 text-[12.5px] font-medium text-sky/80 transition-colors duration-150 hover:border-mint/50 hover:text-mint focus:outline-none focus-visible:ring-2 focus-visible:ring-mint" data-id="element-317" data-mp="2ep33vcyrbzhi">
            <ArrowLeftIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-318" data-mp="1vxk6blni5dmv" />
            {studyDesign.cta}
          </button>
        </div>

        <div className="overflow-y-auto px-8 py-6" data-id="element-319" data-mp="2lko826x8ptf8">
          <dl className="divide-y divide-line border-y border-line" data-id="element-320" data-mp="2pmj9dbf686t0">
            {studyDesign.rows.map(row => <div key={row.label} className="flex gap-6 py-3" data-id="element-321" data-mp="2ud80uqqup3s5">
                <dt className="w-32 shrink-0 text-[10px] uppercase tracking-micro text-mut" data-id="element-322" data-mp="2zckxg37ixp7x">
                  {row.label}
                </dt>
                <dd className="text-[13.5px] leading-snug text-navy" data-id="element-323" data-mp="22nd96nfit20b">{row.value}</dd>
              </div>)}
          </dl>

          <section className="mt-6 rounded-2xl border-l-2 border-mint bg-sky/40 px-6 py-5" data-id="element-324" data-mp="26o6vjcdbe8r3">
            <h3 className="text-[10px] uppercase tracking-micro text-navy" data-id="element-325" data-mp="2blowafh6hho0">
              {studyDesign.limitationsLabel}
            </h3>
            <ul className="mt-3 space-y-2" data-id="element-326" data-mp="3n2f8cf8a93pj">
              {studyDesign.limitations.map(l => <li key={l} className="flex gap-2.5 text-[13px] leading-snug text-mut" data-id="element-327" data-mp="3s0zx9ii340yo">
                  <span className="mt-[7px] h-1 w-1 shrink-0 rounded-full bg-blue" aria-hidden="true" data-id="element-328" data-mp="1gdwr366t6ynr" />
                  {l}
                </li>)}
            </ul>
          </section>

          <p className="mt-5 text-[10.5px] leading-relaxed text-mut" data-id="element-329" data-mp="16o3ga7ehqnkk">{snakReference}</p>
        </div>
      </motion.div>
    </motion.div>;
}